export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M22.5 14H21v3a2 2 0 0 1-2 2h-3v1.5L13 18l3-2.5V17h3v-3h-1.5l2.5-3zM5 17h6v-4H5zm0-6h6V7H5zm4.876 7 1.844-1.536L13 15.396V13h2.729l.235-.28L17.396 11H13V7h6v2.076l1-1.2 1 1.2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6.076z\"/>"
};